const apiConfig = {
    "verifyUrl":"http://15.252.9.66/api/hrms",
    "baseUrl":"https://identiti-hrms.tiburaglobal.com",
    "gatWayUrl":"https://login-api.tiburaglobal.com:8900",
    "dashboard":"http://localhost:8082/",
    "webUrl":"https://synergy-uat.axodesk.com/login",
    "appName": "Identti Front End",
    "apiKey": "apiKey",
    "appId": "6852fe2f2201d00099b78c4b",
    "secrect": "secrect"
}
export default apiConfig;


